import React from 'react';
import PropTypes, { any } from 'prop-types';
import Img from '../../../../Img';
import AvatarV2 from '../../../../cards/PlayerCard/ListViewComponents/AvatarV2';
import RowPlayerBookmark from '../../../../SavedLists/PlayerBookmark/RowPlayerBookmark';
import { BOOKMARK_ROW_ICON_HEIGHT } from '../../../../SavedLists/PlayerBookmark';
import useIsMobile from '../../../../hooks/useIsMobile';

import styles from '../../localizedRankings.scss';

const ResultCard = ({ player, isProfilePlayer, isPowerUser, savedBookmark, bookmarkColumnActive, 'data-testid': dataTestId }) => {
    const { ratingDisplay, rank, playerId, firstName, lastName, location, playerProfileImages } = player || {};
    const { isMobileWidth } = useIsMobile();
    let resultCardClassName = isProfilePlayer ? styles.currentUserResultCard : styles.resultCard;
    if (!isPowerUser && !isProfilePlayer) {
        resultCardClassName = styles.resultCardBlurred;
    }

    return (
        <div className={resultCardClassName} data-testid={dataTestId || undefined}>
            <div className={styles.resultCardContent}>
                <div className={styles.playerInfoContainer}>
                    <AvatarV2 player={player} playerImages={playerProfileImages} data-testid={dataTestId && `${dataTestId}.avatar`} />
                    <div className={styles.playerData}>
                        {isProfilePlayer ? (
                            <p className={styles.currentUserPlayerName} data-testid={dataTestId && `${dataTestId}.player-name`}>{`${firstName} ${lastName}`}</p>
                        ) : (
                            <a href={`/profiles/${playerId}`} className={styles.playerName} data-testid={dataTestId && `${dataTestId}.player-link`}>{`${firstName} ${lastName}`}</a>
                        )}
                        {isMobileWidth ? (
                            <>
                                <div className={styles.playerRatingContainer}>
                                    <p className={styles.playerRating} data-testid={dataTestId && `${dataTestId}.rating`}>{`UTR ${ratingDisplay}`}</p>
                                    <Img src="/img/v4/icon-verified-checkmark-black.svg" alt="Verified" data-testid={dataTestId && `${dataTestId}.verified-icon`} />
                                </div>
                                {location && (
                                    <p className={styles.playerLocation} data-testid={dataTestId && `${dataTestId}.location`}>{location}</p>
                                )}
                            </>
                        ) : (
                            <div className={styles.playerRatingContainer}>
                                <p className={styles.playerRating} data-testid={dataTestId && `${dataTestId}.rating`}>{`UTR ${ratingDisplay}`}</p>
                                <Img src="/img/v4/icon-verified-checkmark-black.svg" alt="Verified" data-testid={dataTestId && `${dataTestId}.verified-icon`} />
                                {location && (
                                    <p className={styles.playerLocation} data-testid={dataTestId && `${dataTestId}.location`}>{`\u2022 ${location}`}</p>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.rankBookmarkGroup}>
                    {isPowerUser ? (
                        <p className={styles.playerRank} data-testid={dataTestId && `${dataTestId}.rank`}>{rank?.toLocaleString()}</p>
                    ) : (
                        <Img src="/img/v2/icons/icon-feature-lock.svg" alt="Locked" data-testid={dataTestId && `${dataTestId}.lock`} />
                    )}
                    {savedBookmark?.enabled ? (
                        <RowPlayerBookmark savedBookmark={savedBookmark} className={`text-v3-blue ${styles.rankBookmark}`} size={BOOKMARK_ROW_ICON_HEIGHT} data-testid={dataTestId && `${dataTestId}.bookmark`} />
                    ) : (bookmarkColumnActive && (
                        // Reserve the bookmark's slot on rows without one (the viewer's own row) so the rank
                        // column stays aligned with the rows that do show a bookmark.
                        <span className={styles.bookmarkPlaceholder} aria-hidden="true" data-testid={dataTestId && `${dataTestId}.bookmark-placeholder`} />
                    ))}
                </div>
            </div>
        </div>
    );
};

ResultCard.propTypes = {
    player: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        playerProfileImages: PropTypes.objectOf(any),
        ratingDisplay: PropTypes.string.isRequired,
        rank: PropTypes.number,
        playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
    isProfilePlayer: PropTypes.bool.isRequired,
    isPowerUser: PropTypes.bool.isRequired,
    bookmarkColumnActive: PropTypes.bool,
    savedBookmark: PropTypes.shape({
        enabled: PropTypes.bool,
        playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        playerName: PropTypes.string,
        isSaved: PropTypes.bool,
        savedListIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        isLoading: PropTypes.bool,
        onSaveSuccess: PropTypes.func,
        onRemoveSuccess: PropTypes.func,
    }),
    'data-testid': PropTypes.string,
};

ResultCard.defaultProps = {
    savedBookmark: null,
    bookmarkColumnActive: false,
    'data-testid': null,
};

export default ResultCard;
